import { styled } from '@mui/material';

export const FooterContainer = styled('div')<{ reportOnly?: boolean }>(({ reportOnly }) => ({
  ...(reportOnly && {
    position: 'absolute',
    left: '-9999px',
    top: 0,
    width: '800px',
    visibility: 'visible',
  }),
}));

export const FooterContent = styled('div')({
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  marginTop: '20px',
});

export const BlueLine = styled('div')({
  width: '80%',
  height: '3px',
  backgroundColor: '#0066cc',
  marginBottom: '15px',
});

export const DisclaimerText = styled('p')({
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  color: '#333',
  margin: 0,
  textAlign: 'center',
});

export const PageNumber = styled('div')({
  position: 'absolute',
  right: 0,
  top: '20px',
  fontFamily: 'Arial, sans-serif',
  fontSize: '16px',
  fontWeight: 'bold',
  color: '#0066cc',
  lineHeight: '3px',
  marginRight: '48px',
});
